import { Config } from "../../react-components-core";
import { defaultTheme } from "../theme";
import componentsConfig from "./components.config";

// const defaultConfig: Omit<Config, "projectName"> = {
const defaultConfig = {
    // themes: { default: defaultTheme, light: lightTheme, dark: darkTheme },
    themes: { default: defaultTheme, light: defaultTheme, dark: defaultTheme },
    translate: (w: string) => w,
    locale: "en",
    validators: {},
    components: componentsConfig,
};

export default defaultConfig;
